class API {

  static register = '/api/register'
  //static login = '/oauth/token'
  static login = '/api/login'
  static loginVrachiRf = '/api/sppvr/loginvrachirf'
  static parameters = '/api/sppvr/parameters'
  static settings = '/api/sppvr/settings'
  static user = '/api/user'
  static userData = '/api/sppvr/userdata'
  static logout = '/api/logout'

  static patients = '/api/sppvr/patients/'

  static appointments = '/api/sppvr/appointments'

  static consultations = '/api/sppvr/consultations'
  static deleteConsultations = '/api/sppvr/del_vc_json/'

  static vcParameters = '/api/sppvr/vcparameters'
  static vcParametersUpdate = '/api/sppvr/vcparameters_update'


  static drugchoice = '/api/sppvr/drugchoice'
  static recommendations = '/api/sppvr/recommendations'
  static prescription = '/api/sppvr/prescription'
  static results = '/api/sppvr/results'

  static treeVc = '/api/sppvr/treevc'




}

export default API



// WEBPACK FOOTER //
// ./src/API.js